import { render, staticRenderFns } from "./mobile.vue?vue&type=template&id=12f8f50e&scoped=true"
import script from "./mobile.vue?vue&type=script&lang=js"
export * from "./mobile.vue?vue&type=script&lang=js"
import style0 from "./mobile.vue?vue&type=style&index=0&id=12f8f50e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12f8f50e",
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/components/footer/footer/mobile.vue
// module id = null
// module chunks = 